export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'long', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Влизане",
    "login.form.hint.user": "Потребителско име",
    "login.form.hint.password": "Парола",
    "login.form.checkbox.remember-me": "Запомни ме",
    "login.form.button.sign-in": "Влизане",
    "login.form.message.invalid-user-credentials": "Потребителското име или паролата е неправилна",
    "login.form.message.user-required": "Въведете потребителско име",
    "login.form.message.password-required": "Въведете парола",
    "login.form.button.forgot-password": "Забравена парола?",
    "error.root-admin-login.title": "Грешка 403 – забранено",
    "error.root-admin-login.message": "Влезли сте като администратор с роля само за четене. За да осъществите достъп до конзолата Web Recovery, влезте като потребител клиент от тип „Клиент“ или администратор"
};
